import angular from 'angular';
import '../core.module';
import { ROUTE_PERMISSIONS } from './route-permissions.constant';

export const MENU_ITEMS = [
  {
    section: 'Principal',
    items: [
      {
        label: 'Dashboard',
        icon: 'grid',
        state: 'app.dashboard',
        permission: ROUTE_PERMISSIONS['app.dashboard']
      },
      {
        label: 'Conversas',
        icon: 'message-circle',
        state: 'app.conversations',
        permission: ROUTE_PERMISSIONS['app.conversations']
      },
      {
        label: 'Contatos',
        icon: 'users',
        state: 'app.contacts',
        permission: ROUTE_PERMISSIONS['app.contacts']
      }
    ]
  },
  {
    section: 'Vendas & Relacionamento',
    items: [
      {
        label: 'CRM',
        icon: 'briefcase',
        state: 'app.crm',
        permission: ROUTE_PERMISSIONS['app.crm']
      },
      {
        label: 'Minha agenda',
        icon: 'calendar',
        state: 'app.calendar',
        permission: ROUTE_PERMISSIONS['app.calendar']
      },
      {
        label: 'Vendas',
        icon: 'shopping-cart',
        state: 'app.sales',
        permission: ROUTE_PERMISSIONS['app.sales']
      },
      {
        label: 'Pagamentos',
        icon: 'credit-card',
        state: 'app.payments',
        permission: ROUTE_PERMISSIONS['app.payments']
      },
      {
        label: 'Produtos e Serviços',
        icon: 'tag',
        state: 'app.products',
        permission: ROUTE_PERMISSIONS['app.products']
      },
      {
        label: 'Suporte',
        icon: 'life-buoy',
        state: 'app.support',
        permission: ROUTE_PERMISSIONS['app.support']
      }
    ]
  },
  {
    section: 'Automação',
    guide: 'automation',
    items: [
      {
        label: 'Agente de IA',
        icon: 'cpu',
        state: 'app.ai-agents',
        permission: ROUTE_PERMISSIONS['app.ai-agents']
      },
      {
        label: 'Chatbots',
        icon: 'git-branch',
        state: 'app.chatbots',
        permission: ROUTE_PERMISSIONS['app.chatbots']
      },
      {
        label: 'Automações',
        icon: 'zap',
        state: 'app.automation',
        permission: ROUTE_PERMISSIONS['app.automation']
      },
      {
        label: 'Campanhas',
        icon: 'send',
        state: 'app.campaigns',
        permission: ROUTE_PERMISSIONS['app.campaigns']
      },
      {
        label: 'Templates',
        icon: 'file-text',
        state: 'app.templates',
        permission: ROUTE_PERMISSIONS['app.templates']
      },
      {
        label: 'Respostas Rápidas',
        icon: 'zap-off',
        state: 'app.quick-replies',
        permission: ROUTE_PERMISSIONS['app.quick-replies']
      }
    ]
  },
  {
    section: 'Gestão',
    items: [
      {
        label: 'Equipes',
        icon: 'users',
        state: 'app.teams',
        permission: ROUTE_PERMISSIONS['app.teams']
      },
      {
        label: 'Membros de Administração',
        icon: 'shield',
        state: 'app.admin-members',
        permission: ROUTE_PERMISSIONS['app.admin-members']
      },
      {
        label: 'Lembretes',
        icon: 'bell',
        state: 'app.reminders',
        permission: ROUTE_PERMISSIONS['app.reminders']
      },
      {
        label: 'Permissões',
        icon: 'lock',
        state: 'app.permissions',
        permission: ROUTE_PERMISSIONS['app.permissions']
      },
      {
        label: 'Números',
        icon: 'phone',
        state: 'app.numbers',
        permission: ROUTE_PERMISSIONS['app.numbers']
      }
    ]
  },
  {
    section: 'Inteligência',
    items: [
      {
        label: 'Relatórios',
        icon: 'bar-chart-2',
        state: 'app.reports',
        permission: ROUTE_PERMISSIONS['app.reports']
      },
      {
        label: 'Analytics',
        icon: 'trending-up',
        state: 'app.analytics',
        permission: ROUTE_PERMISSIONS['app.analytics']
      }
    ]
  },
  {
    section: 'Sistema',
    items: [
      {
        label: 'Conectores',
        icon: 'link-2',
        state: 'app.connectors',
        permission: ROUTE_PERMISSIONS['app.connectors']
      },
      {
        label: 'Integrações',
        icon: 'external-link',
        state: 'app.integrations',
        permission: ROUTE_PERMISSIONS['app.integrations']
      },
      {
        label: 'Configurações',
        icon: 'settings',
        state: 'app.settings',
        permission: ROUTE_PERMISSIONS['app.settings']
      },
      {
        label: 'Auditoria',
        icon: 'shield',
        state: 'app.audit',
        permission: ROUTE_PERMISSIONS['app.audit']
      }
    ]
  }
];

export function homeState(SessionService) {
  const items = MENU_ITEMS.reduce((all, section) => all.concat(section.items), []);
  const allowed = items.find((item) => SessionService.hasPermission(item.permission));
  return allowed ? allowed.state : null;
}

angular.module('app.core').constant('MENU_ITEMS', MENU_ITEMS);
